import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source, true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(source)).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import types from 'prop-types';
import { autobind } from 'core-decorators';
import { styled, StyleSheet, keyframes } from '@rexlabs/styling';
import Tooltip, { PLACEMENTS } from '@rexlabs/tooltip';
import actionMenuButton from './action-menu-button';
var enterAnimation = keyframes({
  '0%': {
    opacity: 0,
    position: 'relative',
    top: '-14px'
  },
  '100%': {
    opacity: 1,
    top: '0px',
    position: 'relative'
  }
});
var exitAnimation = keyframes({
  '0%': {
    opacity: 1,
    transform: 'scale3d(1,1,1)',
    transformOrigin: '85% -80%'
  },
  '100%': {
    opacity: 0,
    transform: 'scale3d(0.8,0.8,0.8)',
    transformOrigin: '85% -80%'
  }
});
var defaultStyles = StyleSheet({
  container: {
    transform: 'translateX(1rem)'
  },
  menu: {
    display: 'block',
    padding: 0,
    minWidth: '100px',
    margin: 0,
    listStyleType: 'none'
  },
  menuItem: {
    cursor: 'pointer',
    display: 'block',
    width: '100%',
    '& a': {
      display: 'block',
      width: '100%'
    },
    '& a:hover': {
      opacity: 0.8
    },
    '& a:active:focus': {
      outline: 'none'
    }
  },
  button: {
    width: '2rem',
    textAlign: 'center',
    boxSizing: 'border-box',
    paddingTop: '0.8rem',
    height: '2.5rem',
    cursor: 'pointer',
    transform: 'translateX(-0.6rem)',
    '&:active:focus': {
      outline: 'none'
    },
    '&:hover': {
      opacity: 0.8
    }
  },
  groupHeading: {
    padding: '15px 10px 5px 10px',
    textTransform: 'uppercase',
    fontSize: '11px',
    fontWeight: 600,
    color: '#B2B1AB'
  }
});
var ActionMenu = (_dec = styled(defaultStyles), _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(ActionMenu, _Component);

  function ActionMenu() {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, ActionMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ActionMenu)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this]).call(_context, args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "_refs", {});

    return _this;
  }

  _createClass(ActionMenu, [{
    key: "toggleOpen",
    value: function toggleOpen() {
      var _this2 = this;

      this.setState(function (s) {
        return _objectSpread({}, s, {
          isOpen: !s.isOpen
        });
      }, function () {
        if (_this2.openedWithKeyboard) {
          _this2._refs.firstLabel.focus();

          _this2.openedWithKeyboard = false;
        }
      });
    }
  }, {
    key: "triggerMenuItem",
    value: function triggerMenuItem(onClick) {
      var _this3 = this;

      var _this$props = this.props,
          shouldAutoClose = _this$props.shouldAutoClose,
          stopPropagation = _this$props.stopPropagation,
          preventDefault = _this$props.preventDefault;
      return function (e) {
        e.persist();
        if (preventDefault) e.preventDefault();
        if (stopPropagation) e.stopPropagation();
        if (shouldAutoClose) _this3.toggleOpen();
        if (onClick) onClick(e);
      };
    }
  }, {
    key: "onEnterPress",
    value: function onEnterPress(callback) {
      return function (e) {
        if (e.key === 'Enter') {
          if (callback) callback(e);
        }
      };
    }
  }, {
    key: "renderMenu",
    value: function renderMenu(props) {
      var _this4 = this;

      var _this$props2 = this.props,
          items = _this$props2.items,
          BeforeItems = _this$props2.BeforeItems,
          AfterItems = _this$props2.AfterItems,
          ItemLabel = _this$props2.ItemLabel,
          s = _this$props2.styles;
      return React.createElement("ul", s('menu'), BeforeItems && React.createElement(BeforeItems, props), _mapInstanceProperty(items).call(items, function (item, index) {
        var label = item.label,
            onClick = item.onClick;
        var isGroupHeading = !!item.isGroupHeading;
        return isGroupHeading ? React.createElement("li", {
          key: index
        }, React.createElement("div", s('groupHeading'), label)) : React.createElement("li", _extends({
          key: index
        }, s('menuItem'), {
          onKeyPress: _this4.onEnterPress(_this4.triggerMenuItem(onClick)),
          tabIndex: 0,
          onClick: _this4.triggerMenuItem(onClick)
        }), React.createElement(ItemLabel, _extends({}, s('menuItemLabel'), {
          ref: function ref(r) {
            index === 0 && (_this4._refs.firstLabel = r);
          }
        }), label));
      }), AfterItems && React.createElement(AfterItems, props));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props3 = this.props,
          s = _this$props3.styles,
          items = _this$props3.items,
          ItemLabel = _this$props3.ItemLabel,
          Button = _this$props3.Button,
          offset = _this$props3.offset,
          arrowMargin = _this$props3.arrowMargin,
          closeDuration = _this$props3.closeDuration,
          tetherStyles = _this$props3.tetherStyles,
          placement = _this$props3.placement,
          distance = _this$props3.distance,
          rest = _objectWithoutProperties(_this$props3, ["styles", "items", "ItemLabel", "Button", "offset", "arrowMargin", "closeDuration", "tetherStyles", "placement", "distance"]);

      var isOpen = this.state.isOpen;
      var button = React.createElement(Button, _extends({
        tabIndex: 0,
        onKeyPress: this.onEnterPress(function () {
          _this5.openedWithKeyboard = true;
        }),
        isOpen: isOpen
      }, s('button')));
      return React.createElement("div", null, React.createElement(Tooltip, _extends({}, rest, {
        offset: offset,
        isOpen: isOpen,
        setOpen: this.toggleOpen,
        arrowMargin: arrowMargin,
        distance: distance,
        tetherStyles: tetherStyles,
        Content: this.renderMenu,
        closeDuration: closeDuration,
        placement: placement
      }), button));
    }
  }]);

  return ActionMenu;
}(Component), _defineProperty(_class2, "propTypes", {
  /**
   * Array of item objects with a label & onClick prop.
   */
  items: types.arrayOf(types.shape({
    label: types.node.isRequired,
    onClick: types.func
  })).isRequired,

  /**
   * Whether or not the menu should close itself after triggering an item.
   */
  shouldAutoClose: types.bool,

  /**
   * Component to render the item label with.
   */
  ItemLabel: types.elementType,

  /**
   * Component to render the button & icon.
   */
  Button: types.elementType,

  /**
   * Offset arrow to move it closer towards the middle of the tooltip. Any CSS unit.
   */
  arrowMargin: types.string,

  /**
   * Tooltip distance from button.
   */
  distance: types.string,

  /**
   * Offset tooltip on its primary axis.
   */
  offset: types.string,

  /*
   * Close animation duration in ms
   */
  closeDuration: types.number,

  /*
   * Position of the action menu
   */
  placement: types.string,
  stopPropagation: types.bool,
  preventDefault: types.bool
}), _defineProperty(_class2, "defaultProps", {
  arrowMargin: '1.8rem',
  distance: '15px',
  offset: '5px',
  shouldAutoClose: true,
  ItemLabel: 'a',
  placement: PLACEMENTS.BOTTOM_END,
  closeDuration: 100,
  tetherStyles: StyleSheet({
    content: {
      transition: 'none'
    },
    opening: {
      animation: "".concat(enterAnimation, " forwards normal 0.2s cubic-bezier(0, 0, 0.16, 0.99)")
    },
    closing: {
      animation: "".concat(exitAnimation, " forwards normal 0.1s cubic-bezier(0, 0, 0.16, 0.99)")
    }
  }),
  Button: function Button(_ref) {
    var isOpen = _ref.isOpen,
        props = _objectWithoutProperties(_ref, ["isOpen"]);

    return React.createElement("div", props, actionMenuButton);
  }
}), _temp)) || _class) || _class);
export default ActionMenu;